import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import getBaseUrl from "../getBaseUrl";
import { BASE_URL, getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
export const doctorFocusBrand = createAsyncThunk(
  "doctorFocusBrand/fetch",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/doctors_focusbrands`,
        {
          detail: [
            {
              loc: ["string", 0],
              msg: "string",
              type: "string",
            },
          ],
        },
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders(),
            "business-function": "none",
            client: payload.client ? payload.client : "UT",
          },
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error details:", error); // Log the whole error for debugging
      const errorMsg = error?.response?.data?.detail || "Failed to load!";
      dispatch(showSnackbar({ message: errorMsg, severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);
const doctorsbrandSlice = createSlice({
  name: "doctorsbrands",
  initialState: {
    isLoading: false,
    doctors: [],
    isError: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doctorFocusBrand.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(doctorFocusBrand.fulfilled, (state, action) => {
      state.isLoading = false;
      state.doctors = action.payload;
    });
    builder.addCase(doctorFocusBrand.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default doctorsbrandSlice.reducer;
